export const HIDE_TOB_BAR_INFO_WIDTH = 1200;

export const isHideTopBar = (): boolean => {
    // @ts-ignore
    return window._innerWidth < HIDE_TOB_BAR_INFO_WIDTH;
};
